import { ChangeDetectionStrategy, Component, Input, NgZone, ViewChild } from '@angular/core';
import { System } from '@app/core/resources/system';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';

@Component({
    selector: 'app-landing-system-img',
    templateUrl: './landing-system-img.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./landing-system-img.component.scss']
})
export class LandingSystemImgComponent {
    @Input() public system: System = new System();
    @Input() public titleHero: string = '';
    @Input() public urlImage: string = '';
    @Input() public alt: string = '';
    @ViewChild('animationItem', { static: false }) public animationItem!: AnimationItem;

    public lottieOptions: AnimationOptions = {
        path: '../../../../assets/images/landing-system/system-animation.json'
    };

    public constructor(private ngZone: NgZone) {}

    public onAnimationLoaded(animationItem: AnimationItem): void {
        this.ngZone.runOutsideAngular(() => {
            animationItem.addEventListener('loopComplete', () => {
                this.animationItem.goToAndStop(this.animationItem.totalFrames - 1, true);
            });
            this.animationItem = animationItem;
        });
    }

    public animationReverse(): void {
        this.animationItem.setDirection(-1);
        this.animationItem.play();
        this.animationItem.setLoop(false);
        this.animationItem.addEventListener('complete', () => {
            if (this.animationItem.firstFrame === 0) {
                this.animationItem.stop();
            }
        });
    }

    public animationMove(): void {
        this.animationItem.setDirection(1);
        this.animationItem.play();
        this.animationItem.setLoop(false);
        this.animationItem.addEventListener('complete', () => {
            this.animationItem.goToAndStop(this.animationItem.totalFrames - 1, true);
        });
    }
}
